import { FC, ReactElement } from 'react';

type Props = {
  children: ReactElement<any>;
};

const HomeContent: FC<Props> = ({ children }): ReactElement<any> => {
  return <div className="home-aside pa3 relative">{children}</div>;
};

export default HomeContent;
